import { UilCalender } from "@iconscout/react-unicons";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "./DateTimePicker.css";

type Props = {
  value?: Date;
  onChange?: (value: Date) => void;
};

export function CustomDatePicker({ value, onChange }: Props) {
  const [showCalander, setShowCalander] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date | null | undefined>(
    value
  );

  const handleOnChange = (value: Date | null) => {
    value && setSelectedDate(value);
    onChange && value && onChange(value);
  };

  return (
    <div
      onClick={() => setShowCalander(!showCalander)}
      className="h-11 rounded-md border border-page-border flex justify-center cursor-pointer items-center bg-input-bg overflow-hidden focus:border-blue-500 invalid:outline-red-500 disabled:text-gray-300"
    >
      <div className="h-full w-full  bg-transparent mx-4 border-r border-page-border border-0 focus:border-0">
        <DatePicker
          className="h-11 w-40 rounded-md flex justify-center border-0 cursor-pointer items-center bg-input-bg  focus:border-0"
          selected={selectedDate}
          showPopperArrow={false}
          timeIntervals={15}
          onChange={(date) => handleOnChange(date)}
          calendarClassName="font-avenir rounded-md border-0 border-page-border flex justify-center"
        />
      </div>
      <UilCalender className="text-gray-300 w-4 h-4 mr-4" />
    </div>
  );
}
